jQuery(function ($) {
  var productsSwiper;

  // Intersection Observer を設定
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // スライダーを初期化して開始
          if (!productsSwiper) {
            productsSwiper = new Swiper('.js-products-swiper', {
              loop: true,
              speed: 1500,
              slidesPerView: 1,
              centeredSlides: true,
              autoplay: {
                delay: 2000, // 3秒ごとにスライド
                disableOnInteraction: false, // ユーザー操作後も自動再生を続ける
              },
              pagination: {
                el: '.swiper-pagination',
                clickable: true,
              },
            });
          } else {
            // スライドを再開
            productsSwiper.autoplay.start();
          }
        } else {
          // スライドを停止
          if (productsSwiper) {
            productsSwiper.autoplay.stop();
          }
        }
      });
    },
    {
      threshold: 0.1, // 要素が10%見えたときに発火
    }
  );

  // .js-products-swiper の位置を監視
  var target = document.querySelector('.js-products-swiper');
  if (target) {
    observer.observe(target);
  }
});
